import { FC, useEffect, useMemo } from 'react'
import { Card, Fade, Input, Select } from '@chakra-ui/react'

import { FormItem } from 'components'

type Props = {
  name: string
  dataType: string
  label: string
  register: any
  setValue: any
  watch: any
}

const DynamicMetadatas: FC<Props> = ({ label, name, dataType, register, setValue, watch }) => {
  const inputTypes = useMemo(() => {
    return [
      { label: 'Texto', value: 'STRING' },
      { label: 'Texto largo', value: 'TEXT' },
      { label: 'Número', value: 'NUMBER' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Sim ou Não', value: 'BOOLEAN' },
    ]
  }, [])

  useEffect(() => {
    if (setValue && watch) {
      const type = watch(dataType)
      if (!type) setValue(dataType, 'STRING')
    }
  }, [dataType])

  return (
    <Fade in>
      <Card>
        <FormItem label={label}>
          <Input {...register(name)} />
        </FormItem>

        <FormItem label="Tipo de dado">
          <Select defaultValue="STRING" {...register(dataType)}>
            {inputTypes.map(({ value, label }) => {
              return (
                <option key={label} value={value}>
                  {label}
                </option>
              )
            })}
          </Select>
        </FormItem>
      </Card>
    </Fade>
  )
}

export default DynamicMetadatas
